import Login from "@/pages/Login.vue"
import UserInfo from "@/pages/UserInfo.vue"
import ClassroomList from "@/pages/ClassroomList.vue"

import Classroom from "@/pages/Classroom/Classroom.vue"
import ClassroomInfo from "@/pages/Classroom/ClassroomInfo.vue"

import Download from "@/pages/Classroom/Download.vue"

import Homework from "@/pages/Homework/Homework.vue"
import HomeworkList from "@/pages/Homework/HomeworkList.vue"
import HomeworkDetails from "@/pages/Homework/HomeworkDetails.vue"
import HomeworkInfo from "@/pages/Homework/HomeworkInfo.vue"
import HomeworkAnswerList from "@/pages/Homework/HomeworkAnswerList.vue"
import HomeworkAnswer from "@/pages/Homework/HomeworkAnswer.vue"

import Discussion from "@/pages/Discussion/Discussion.vue"
import DiscussionList from "@/pages/Discussion/DiscussionList.vue"
import DiscussionDetails from "@/pages/Discussion/DiscussionDetails.vue"

import Members from "@/pages/Classroom/Members.vue"


import ErrorPage from "@/pages/ErrorPage.vue"


export default {
    routes: [
        {
            path: "/",
            component: Login,
            beforeEnter: (to, from, next) => {
                next("/login");
            }
        },
        { path: "/login", component: Login },
        { path: "/classroom-list", component: ClassroomList },
        { path: "/userinfo/:id", component: UserInfo },
        {
            path: "/class/:class_id", component: Classroom,
            children: [
                { path: "", component: ClassroomInfo },
                {
                    path: "discussions",
                    component: Discussion,
                    children: [
                        { path: "", component: DiscussionList },
                        { path: ":discussion_id", component: DiscussionDetails }
                    ]
                },
                { path: "downloads", component: Download },
                {
                    path: "homeworks",
                    component: Homework,
                    children: [
                        { path: "", component: HomeworkList },
                        {
                            path: ":homework_id",
                            component: HomeworkInfo,
                            children: [
                                { path: "", component: HomeworkDetails },
                                { path: "answers/:answer_id", component: HomeworkAnswer },
                                { path: "answers", component: HomeworkAnswerList }
                            ]
                        }
                    ]
                },
                { path: "members", component: Members }
            ]
        },
        { path: "*", component: ErrorPage }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
}